import jsPDF from 'jspdf';
import 'jspdf-autotable';
import React, { useState } from 'react';
import logo from '../assets/images/finaculator1.png';  
import addWatermark from './watermark';
import ReactGA from 'react-ga4';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import DownloadIcon from '@mui/icons-material/Download'; 
import Button from '@mui/material/Button';
interface PDFGeneratorProps {
  principal: number; 
  totalAmount: number | null;
  totalInterest: number | null;
  period: number | null;
  periodUnit: 'years' | 'months';
  rate: string;
  isCalculated: boolean;
}

const PDFGenerator: React.FC<PDFGeneratorProps> = ({
  principal,
  totalAmount,
  totalInterest,
  period,
  periodUnit,
  rate,
  isCalculated,
}) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const generatePDF = () => {
    if (!isCalculated) {
      setSnackbarMessage("Please calculate the values before downloading the PDF.");
      setSnackbarOpen(true);
      return;
    }
   

    if (!principal || !totalAmount || !totalInterest || period === null || periodUnit === null || !rate ) {
      setSnackbarMessage("Please ensure all fields are filled before downloading the PDF.");
      setSnackbarOpen(true);
      return;
    }
    ReactGA.event({
      category: 'Fixed Deposit PDF',
      action: 'Fixed Deposit PDF Button',
      label: 'Fixed Deposit PDF',
    });

    const doc = new jsPDF();
    const watermarkWidth = 100;  
    const watermarkHeight = 100;
    const headerFontSize = 20;
    const tableSpacing = 20; 
    const lineSpacing = 10; 

    doc.setFontSize(headerFontSize);
    
    const fixedDepositSummary = 'Fixed Deposit Summary';
    doc.text(fixedDepositSummary, 14, tableSpacing);
console.log("@@:"+rate)
    const annualRate = parseFloat(rate) / 100;
    let finalTotalAmount = 0;
    let finalTotalInterest = 0;
    let interestData: { period: string, interest: string, total: string }[] = [];
    let currentAmount = principal;

    const summaryTableData = [
      { label: 'Principal Amount', value: `${Math.ceil(principal).toLocaleString()}` },
      { label: 'Total Interest Earned', value: `${Math.ceil(totalInterest || 0)}` },
      { label: 'Total Amount', value: `${Math.ceil((principal || 0) + (totalInterest || 0))}` },
      { label: 'Period', value: `${period} ${periodUnit}` },
      { label: 'Interest Rate', value: `${rate}%` },
    ];

    if (periodUnit === 'years') {
      const periodYears = period || 5; 

      finalTotalAmount = principal * Math.pow(1 + annualRate, periodYears); 
      finalTotalInterest = finalTotalAmount - principal;

      for (let year = 1; year <= periodYears; year++) {
        const interestEarned = currentAmount * annualRate;
        currentAmount += interestEarned;

        interestData.push({
          period: `${year} Year`, 
          interest: `${Math.round(interestEarned).toLocaleString()}`, 
          total: `${Math.round(currentAmount).toLocaleString()}`, 
        });
      }
    } else if (periodUnit === 'months') {
      const periodMonths = period || 5; 
      const monthlyRate = annualRate / 12;
      console.log("@@@ month :",monthlyRate);
      console.log(annualRate)

      finalTotalAmount = principal * Math.pow(1 + monthlyRate, periodMonths);
      finalTotalInterest = finalTotalAmount - principal;

      for (let month = 1; month <= periodMonths; month++) {
        const interestEarned = currentAmount * monthlyRate;
        currentAmount += interestEarned;

        interestData.push({
          period: `${month} Month`, 
          interest: `${Math.round(interestEarned).toLocaleString()}`, 
          total: `${Math.ceil(currentAmount).toLocaleString()}`, 
        });
      }
    }

     doc.autoTable({
      head: [['Description', 'Amount']],
      body: summaryTableData.map(item => [item.label, item.value]),
      startY: tableSpacing + lineSpacing,
      headStyles: { fillColor: [22, 160, 133] },

    });
    
    const finalY = doc.autoTable?.finalY || (tableSpacing + lineSpacing + 40); 

    const interestTableData = interestData.map(item => [item.period, item.interest, item.total]);

    doc.autoTable({
      head: [['Period', 'Interest Earned', 'Total Amount']], 
      body: interestTableData, 
      startY: finalY + lineSpacing + 20, 
      styles: { halign: 'center' },
      headStyles: { fillColor: [22, 160, 133] },


    });

    addWatermark(doc, logo, watermarkWidth, watermarkHeight);
    const img = new Image();
    img.src = logo;
    img.onload = () => {
      const now = new Date();
      const padZero = (num: string | number) => ("0" + num).slice(-2);
      const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())}`;
      const formattedTime = `${padZero(now.getHours())}-${padZero(now.getMinutes())}-${padZero(now.getSeconds())}`;
      const timestamp = `${formattedDate}_${formattedTime}`;
      const fileName = `finaculator_fd_calculator_${timestamp}.pdf`;
      doc.save(fileName);
    };
  };  

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
      <Button
        variant="contained"
        color="success"
        onClick={generatePDF}
        style={{ marginTop: -70 }} 
        startIcon={<DownloadIcon />}
      >
        Download PDF
      </Button>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Adjust position here
      >
        <MuiAlert onClose={handleSnackbarClose} severity="warning" sx={{ width: '100%' }}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default PDFGenerator;
